import { Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { ClipboardList } from "lucide-react";
import { api } from "../lib/api";
import type { ProcessAlerts } from "../lib/processes";

export function ProcessNotifications() {
  const alerts = useQuery({
    queryKey: ["process-alerts"],
    queryFn: () => api<ProcessAlerts>("/v1/processes/alerts"),
    refetchInterval: 60000
  });
  const count = alerts.data?.count || 0;
  return (
    <Link
      to="/processes"
      search={{ tab: "alerts" }}
      className={`icon-button notification process-notification ${count ? "has-pending" : ""}`}
      aria-label={`Processos: ${count} pendências e etapas liberadas`}
      title={`Processos: ${count} pendências e etapas liberadas`}
    >
      <ClipboardList size={19} />
      {count > 0 && <b>{count > 99 ? "99+" : count}</b>}
    </Link>
  );
}
